import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ProductsService } from 'src/app/products.service';
import { CommentService } from 'src/app/comment.service';
import { AuthService } from 'src/app/auth.service';
import { CounterService } from 'src/app/counter.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  product;
  slideConfig = {"slidesToShow": 1, "slidesToScroll": 1,asNavFor:".slider-nav",};
  slideThumbs = {"slidesToShow": 4, "slidesToScroll": 4,asNavFor:".slider-for",};
  constructor(private counterService:CounterService,private route: ActivatedRoute,private productService:ProductsService,private commentService:CommentService,public authService:AuthService) { }
  rate;
  comment:string;
  counter:number = 1
  ngOnInit(): void {
    this.route.params.subscribe(
      (params:Params)=>{
        // this.productService.getProductInfo(+params['id'])
        // this.product=this.productService.getProductInfo(+params['id']) 
        // // console.log(this.productService.getProductInfo(+params['id']))
        this.productService.getProductInfo(+params['id']).subscribe(
          (result)=>{
            this.product = result;
            // console.log(this.product)
          }
        )
      }
    )
    // console.log(this.comment)
    // this.counter = this.counterService.countervalue
  }
  addComment(id:number){
   
  
    let productComment = {
      product_id:id,
      text:this.comment,
      rate:(this.rate == undefined)?0:this.rate
    }
    this.productService.addComment(productComment).subscribe(
      (result)=>{
        this.route.params.subscribe(
          (params:Params)=>{
            this.productService.getProductInfo(+params['id']).subscribe(
              (result)=>{
                this.product = result;
                // console.log(this.product)
              }
            )
          }
        )
        // console.log(result)
      }
    )
    
  }
  increase(){
    this.counter += 1
  }
  decrease(){
    if(this.counter>1){

      this.counter -= 1
    }
    // console.log(this.counter)
  }
}
